import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeatCalanderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 0.666016L12.6667 3.33268L10 5.99935",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.666016 6.66536V5.9987C0.666016 5.29145 0.946967 4.61318 1.44706 4.11308C1.94716 3.61298 2.62544 3.33203 3.33268 3.33203H12.666M3.33268 13.9987L0.666016 11.332L3.33268 8.66536",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.666 8V8.66667C12.666 9.37391 12.3851 10.0522 11.885 10.5523C11.3849 11.0524 10.7066 11.3333 9.99935 11.3333H0.666016",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRepeatCalanderIcon;
